import { ReactNode, useState } from "react";
import NavigationContext from "@/contexts/navigation";

interface Props {
  children: ReactNode
}

export default function NavigationProvider({ children }: Props) {
  const [open, setOpen] = useState(true);

  const value = {
    open,
    toggleDrawer: () => setOpen(prev => !prev),
    closeDrawer: () => setOpen(false),
    openDrawer: () => setOpen(true),
  }

  return (
    <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
  )
}